import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {AlgoliaSearchBoxComponent} from './algolia-search-box.component';
import {IconsModule} from '../icons/icons.module';
import {VoiceSearchComponent} from './voice-search/voice-search.component';
import {RecommendedModule} from '../recommended/recommended.module';

@NgModule({
  declarations: [AlgoliaSearchBoxComponent, VoiceSearchComponent],
  exports: [AlgoliaSearchBoxComponent],
  imports: [
    CommonModule,
    FormsModule,
    IconsModule,
    RecommendedModule,
  ],
})
export class AlgoliaSearchBoxModule { }
